module.exports = __webpack_public_path__ + "img/preview-2.32188908.webp";